import {
    OpenStreetMapResult,
    useOpenStreetMapQuery,
} from 'app/agriculture/routes/BackOffice/FarmCreate/components/useOpenStreetMapQuery';
import './AddressResults.scss';

export function AddressResults({
    searchTerm,
    onSelect = () => {
        /* do nothing */
    },
}: {
    searchTerm: string;
    onSelect?: (result: OpenStreetMapResult) => void;
}) {
    const addressResults = useOpenStreetMapQuery(searchTerm);

    return (
        <div className="AddressResults">
            {addressResults.length > 0 ? null : <p>No results found</p>}
            {addressResults.map((result) => (
                <button
                    className="AddressResults__result"
                    key={result.properties.OSMId}
                    onClick={() => {
                        onSelect(result);
                    }}
                >
                    {result.properties.displayName}
                </button>
            ))}
        </div>
    );
}
